import { Directive, HostListener, Input } from '@angular/core';
import { MarketingActionButton, MarketingTrayButtonAction } from '../../../common';
import { AbstractPageScreenService } from '../../components/page-screen/abstract-page-screen.service';
import { AbstractNavigationService } from '../../services';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[osnSharedMarketingActionButton]',
})
export class MarketingActionButtonDirective {
  @Input('osnSharedMarketingActionButton') public actionButton: MarketingActionButton;

  constructor(private readonly navigationService: AbstractNavigationService, private readonly pageService: AbstractPageScreenService) {}

  @HostListener('click')
  public onClick() {
    switch (this.actionButton.action) {
      case MarketingTrayButtonAction.SignIn:
        this.pageService.signIn();
        break;
      case MarketingTrayButtonAction.SignUp:
      case MarketingTrayButtonAction.RenewOrCompleteSubscription: // GATEWAY will handle prospect and churned users
        this.pageService.signUp();
        break;
      case MarketingTrayButtonAction.NewPassword:
        this.pageService.addNewPassword();
        break;
      case MarketingTrayButtonAction.Content:
        const detailPageType = this.actionButton.targetContentGuid.startsWith('SR') ? 'seriesDetails' : 'movieDetails';
        this.navigationService.navigate(detailPageType, this.actionButton.targetContentGuid);
        break;
      case MarketingTrayButtonAction.CustomUrl:
        window.open(this.actionButton.targetUrl, '_blank');
        break;
      case MarketingTrayButtonAction.CxbPage:
        this.navigationService.navigate('page', this.actionButton.targetPageSlug);
        break;
      default:
        return;
    }
  }
}
